require('./bootstrap-app');

const Handler = require('./handler')

if (typeof Equipment === 'object' && typeof Handler[Equipment.handler] === 'function') {
    Handler[Equipment.handler]()
}